<template>
	<div class="order-body">
		<div class="fx-header">
			<p>开通微企付<i class="el-icon-refresh refresh-icon" @click="openPage"></i></p>
		</div>
		<div class="wei-content">
			<img src="~/images/icon/wqf-icon.png" class="wei-icon">
			<div class="wei-right">
				<div class="wei-title">微企付
					<img src="~/images/icon/wqf-opening.png" style="width:60px" v-if="openStatus === 0" class="result-icon">
					<img src="~/images/icon/wqf-opened.png" v-if="openStatus === 1" class="result-icon">
					<img src="~/images/icon/wqf-failed.png" v-if="openStatus === 2" class="result-icon">
				</div>
				<div class="wei-des">
					<div style="margin-right:60px">腾讯旗下支付产品，为小微企业及个体工商户提供资金收付，资金对账等服务</div>
					<div>
						<el-button type="primary" style="width:128px" size="mini" v-if="openStatus === 1 && AuthorityList['01_0009_0002_00']" @click="goRecharge">订单支付费率充值</el-button>
						<el-button type="primary" style="width:128px" size="mini" v-if="openStatus === 1 && AuthorityList['01_0009_0003_00']" @click="goPreRecharge">预付货款专项充值</el-button>
						<el-button type="primary" style="width:80px" size="mini" v-if="(openStatus === 1 || openStatus === -2) && AuthorityList['01_0009_0001_00']" @click="goOpen">立即开通</el-button>
						<el-button type="primary" style="width:80px" size="mini" v-if="openStatus === 2 && AuthorityList['01_0009_0001_00']" @click="goOpen">重新开通</el-button>
						<el-button type="primary" style="width:100px" size="mini" v-if="openStatus === 0 && AuthorityList['01_0009_0001_00']" @click="checkOpen">查看开通结果</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				max-height="450px"
				ref='table'
				border
				stripe
			>
				<el-table-column
					prop="entId"
					label="商家ID"
					align="center">
				</el-table-column>
				<el-table-column
					prop="entName"
					label="商家全称"
					align="center">
				</el-table-column>
				<el-table-column
					prop="entAccountId"
					label="集团银行账号ID"
					align="center">
				</el-table-column>
				<el-table-column
					prop="bankCardNumberLast4"
					label="开通收款账号后四位"
					align="center">
				</el-table-column>
				<el-table-column
					prop="openflag"
					label="开通分账"
					align="center">
					<template slot-scope='scope'>
						<el-button v-if="scope.row.openflag === 1 && scope.row.status === 1" style="cursor: auto;color:var(--fx-primary-color)" size="mini" type="text">已开通</el-button>
						<el-button v-if="scope.row.openflag === 1 && scope.row.status === 1" style="color:red;margin-left: 20px;" size="mini" type="text" @click="openFlagChange(scope.row, 0)">关闭分账</el-button>
						<el-button v-if="scope.row.openflag === 2 && scope.row.status === 1" size="mini" @click="openIngClick" type="text">查看开通结果</el-button>
						<el-button v-if="scope.row.openflag === 0 && scope.row.status === 1" size="mini" @click="openFlagClick(scope.row)" type="text">申请开通</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog
			title="基础信息"
			:visible.sync="showOpen"
			class="dialog-title"
			width="800px"
			:close-on-click-modal="false">
			<openPay @dialogClose="dialogClose" @refreshClose="refreshClose" v-if="showOpen"/>
		</el-dialog>
		<el-dialog
			title="提示"
			:visible.sync="showError"
			class="dialog-title"
			width="600px"
			:close-on-click-modal="false">
			<div class="error-box">{{erroMsg}}</div>
			<div class="see-btn">
				<el-button size="mini" type="primary" @click="iSee">我知道了</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import openPay from '@/components/weiPayList/openPay.vue'
export default {
	name: 'weiPay',
	components: {
		openPay
	},
	data () {
		return {
			AuthorityList: {
				'01_0009_0001_00': false,
				'01_0009_0002_00': false,
				'01_0009_0003_00': false
			},
			staff: [],
			orderKey: '',
			orderBy: '',
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			tabParams: {},
			totalOrderCount: 0,
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			ids: [],
			options: [],
			showOpen: false,
			openStatus: -2,
			openId: '',
			matchbillcenterflag: false,
			showError: false,
			erroMsg: ''
		}
	},
	created () {
		this.checkSmallCategory()
		this.$fxEventBus.$emit('setMenu', '2-10')
		this.getAuthority('01_0009_0000_00')
		this.openPage()
	},
	methods: {
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag === 1
			})
			// })
		},
		openIngClick () {
			this.$alert('正在开通分帐中，请耐心等待', '提示', {
				confirmButtonText: '确定'
			})
		},
		openFlagClick (row) {
			this.$confirm('开启分帐后，订单支付的资金将转存在虚拟账号，需要在分账平台手动提现到银行卡，您确认要开通分账功能吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.openFlagChange(row, 2)
			}).catch(() => {
			})
		},
		openFlagChange (row, type) {
			let params = {
				id: row.id,
				openflag: type
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlReport}/shop/tenpay/productapplication/updateopenflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.openPage()
				} else {
					if (res.code === 1) {
						this.erroMsg = res.msg
						this.showError = true
					} else {
						this.$message.error(res.msg)
					}
				}
			})
		},
		iSee () {
			this.showError = false
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		goOpen () {
			this.showOpen = true
		},
		dialogClose () {
			this.showOpen = false
		},
		refreshClose () {
			this.showOpen = false
			this.openPage()
		},
		goRecharge () {
			this.$router.push('/main/weiPayList')
		},
		goPreRecharge () {
			this.$router.push('/main/weiPrePayList')
		},
		openPage () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/shop/tenpay/productapplication/status`
			}).then(res => {
				if (res.result) {
					this.openId = res.data.length === 0 ? '' : res.data[0].requesno
					this.openStatus = res.data.length === 0 ? -2 : res.data[0].status
					this.tableData = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		checkOpen () {
			this.$store.dispatch('requestPost', {
				url: `/quickorder/ns/v1/shop/tenpay/productapplication/link/${this.openId}`
			}).then(res => {
				if (res.result) {
					this.$fxGoBlank(res.data.pc_web.url)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.staff = data.staff
			this.dateValue = data.dateValue

			this.page = 1
			this.findOrderList()
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findOrderList()
		},
		findOrderList () {
			this.tableData = []
			let params = {
				staffIds: this.staff,
				orderKey: this.orderKey,
				orderBy: this.orderBy,
				page: this.page,
				size: this.size
			}
			if (this.dateValue.length > 0) {
				params.beginDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/commissionResultSummaryList`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				res.recordList.forEach(e => {
					if (!(String(e.sumcommissionmoney).indexOf('.') !== -1 && String(e.sumcommissionmoney).split('.')[1].length > 2)) {
						e.sumcommissionmoney = this.$fxUtils.toFixedSHW(e.sumcommissionmoney, 2)
					}
					if (!(String(e.commissionmoney).indexOf('.') !== -1 && String(e.commissionmoney).split('.')[1].length > 2)) {
						e.commissionmoney = this.$fxUtils.toFixedSHW(e.commissionmoney, 2)
					}
					if (!(String(e.nocommissionmoney).indexOf('.') !== -1 && String(e.nocommissionmoney).split('.')[1].length > 2)) {
						e.nocommissionmoney = this.$fxUtils.toFixedSHW(e.nocommissionmoney, 2)
					}
					e.staffname = e.staffname.split(',')
					e.name = e.staffname[e.staffname.length - 1]
				})
				this.tableData = res.recordList
			})
		},
		findUserName () {
			let params = {
				userName: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/getStaffInfoForCondition`,
				data: params
			}).then(res => {
				this.options = res.data
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.refresh-icon {
		margin-left: 5px;
		color: var(--fx-primary-color);
		cursor: pointer
	}
	.wei-content {
		display: flex;
		padding: 20px 0 0 20px;
		.wei-icon {
			width: 68px;
			height: 68px;
			flex-shrink: 0;
			margin-right: 17px
		}
		.wei-right {
			text-align: left;
			.wei-title {
				display: flex;
				align-items: center
				font-size: 14px;
				color: #595959;
				font-weight: bold
				.result-icon {
					width: 46px;
					height: 22px;
					flex-shrink: 0;
					margin-left: 17px
				}
			}
			.wei-des {
				display: flex;
				align-items: center;
				margin-top: 10px;
			}
		}
	}
	.main-table-box {
		width: 800px;
		margin-top: 20px;
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
	.error-box {
		color: #333;
		padding: 0 20px
	}
	.see-btn {
		text-align: center;
		margin-top: 30px
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
